import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {IEntityWithIDTranslations, IEntityWithTranslations, IErrorResponse} from "../../../../../../../types";
import {
    deletedAdmission,
    deletedRestoreAdmission,
    setAdmissionData,
    setAdmissionRestoreData,
    updateAdmission
} from "../store/admissionBasisSlice";

const GetAdmission = createAsyncThunk(
    "get/admission",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get("/student-abmission");
            dispatch(setAdmissionData({data: response.data}));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const SetAdmission = createAsyncThunk(
    "set/admission",
    async (data: IEntityWithTranslations, {rejectWithValue}) => {
        try {
            return await request.post("/student-abmission", data);

        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteAdmission = createAsyncThunk(
    "delete/admission",
    async (id: number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.delete(`/student-abmission/${id}`);

            dispatch(deletedAdmission(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditAdmission = createAsyncThunk(
    "edit/location",
    async (data: IEntityWithIDTranslations, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.put(`/student-abmission/${data.id}`, data);
            dispatch(updateAdmission(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeleteAdmission = createAsyncThunk(
    "get/delete/admission",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get(`/student-abmission/deleted-items`);
            dispatch(setAdmissionRestoreData(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteAdmission = createAsyncThunk(
    "restore/delete/admission",
    async (id: number, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.post(`/student-abmission/restore/${id}`);
            dispatch(deletedRestoreAdmission(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetAdmission,
    SetAdmission,
    DeleteAdmission,
    EditAdmission,
    GetDeleteAdmission,
    RestoreDeleteAdmission
};
